export class EnvironmentDetails {
    'environment';
    'isOverridden';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "environment",
            "baseName": "environment",
            "type": "Environment",
            "format": ""
        },
        {
            "name": "isOverridden",
            "baseName": "isOverridden",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnvironmentDetails.attributeTypeMap;
    }
    constructor() {
    }
}
